<template>
  <div class="ddd">
    <h1>About</h1>
   {{user}}
   {{title}}
   <button type="button" value="" @click="SetName()">set name</button>  
  </div>
</template>

<script>
  export default {
    methods: {
      SetName() {        
        let item = 'Get groceries';
        this.$store.dispatch('SET_NAME', item);
      }
    },
    computed: {
      user(){
        console.log("user from getter: ", this.$store.getters.USER);
        return this.$store.getters.USER;
      },
      title(){
        return this.$store.getters.TEXT
      }
    }
  }
</script>

<style scoped>
.ddd{
  margin-top: 150px;
}
  
</style>
